// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseModal_close__h029c","bar":"CloseModal_bar__r_9H3","float":"CloseModal_float__YO11h","margin":"CloseModal_margin__e0FPP"};